import React from 'react';

interface ManagerMobileSidebarProps {
  showMobileSidebar: boolean;
  setShowMobileSidebar: (show: boolean) => void;
  activeTab?: string;
  onCreditMoney?: () => void;
  onLogout?: () => void;
}

const navItems = [
  { id: 'home', label: 'Home', icon: '🏠', path: '/manager' },
  { id: 'account', label: 'My Account', icon: '👤', path: '/manager/account' },
  { id: 'payouts', label: 'Payouts', icon: '💰', path: '/manager/payouts' },
  { id: 'reports', label: 'Reports', icon: '📊', path: '/manager/reports' },
  { id: 'merchants', label: 'My Merchants', icon: '🏪', path: '/manager/merchants' },
  { id: 'merchant-reports', label: 'Merchant Reports', icon: '💳', path: '/manager/merchant-report-history' },
  { id: 'settings', label: 'Settings', icon: '⚙️', path: '/manager/settings' },
];

const ManagerMobileSidebar: React.FC<ManagerMobileSidebarProps> = ({
  showMobileSidebar,
  setShowMobileSidebar,
  activeTab = 'home',
  onCreditMoney,
  onLogout,
}) => {
  const close = () => setShowMobileSidebar(false);
  const navItemBase =
    'flex items-center gap-4 py-4 px-5 w-full text-left border-none border-l-4 border-l-transparent bg-transparent cursor-pointer transition-all hover:bg-violet-500/10 hover:border-l-violet-500';
  const navItemActive = 'bg-violet-500/15 border-l-violet-500';

  return (
    <>
      <button
        type="button"
        className="hidden max-md:flex fixed top-4 right-4 z-[9999] w-11 h-11 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 text-white border-none text-2xl cursor-pointer shadow-lg items-center justify-center hover:scale-105 active:scale-95 transition-transform"
        onClick={() => setShowMobileSidebar(!showMobileSidebar)}
        aria-label="Toggle sidebar"
      >
        ☰
      </button>

      {showMobileSidebar && (
        <div
          className="fixed inset-0 bg-black/50 z-[1002] backdrop-blur-sm max-md:block hidden"
          onClick={close}
          aria-hidden
        />
      )}

      <div
        className={`fixed top-0 left-0 w-[280px] h-screen bg-white z-[1003] shadow-xl transition-transform duration-300 overflow-y-auto max-md:block hidden ${
          showMobileSidebar ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between p-5 bg-gradient-to-br from-violet-500 to-purple-600 text-white">
          <h3 className="m-0 text-xl font-semibold">Menu</h3>
          <button
            type="button"
            className="w-9 h-9 flex items-center justify-center rounded-lg bg-transparent border-none text-white text-2xl cursor-pointer hover:bg-white/20 transition-colors"
            onClick={close}
          >
            ✕
          </button>
        </div>
        <nav className="flex flex-col py-2">
          {navItems.map(({ id, label, icon, path }) => (
            <button
              key={id}
              type="button"
              className={`${navItemBase} ${activeTab === id ? navItemActive : ''}`}
              onClick={() => {
                close();
                window.location.href = path;
              }}
            >
              <span className="text-xl w-7 text-center">{icon}</span>
              <span className="text-sm font-medium text-slate-800">{label}</span>
            </button>
          ))}
          <button
            type="button"
            className={navItemBase}
            onClick={() => {
              onCreditMoney?.();
              close();
            }}
          >
            <span className="text-xl w-7 text-center">💵</span>
            <span className="text-sm font-medium text-slate-800">Credit Money</span>
          </button>
          <button
            type="button"
            className={`${navItemBase} mt-5 pt-5 border-t border-slate-200 hover:bg-red-500/10 hover:border-l-red-500`}
            onClick={() => {
              onLogout?.();
              close();
            }}
          >
            <span className="text-xl w-7 text-center">🚪</span>
            <span className="text-sm font-medium text-slate-800">Logout</span>
          </button>
        </nav>
      </div>
    </>
  );
};

export default ManagerMobileSidebar;
